/**
 * HYGAD i18n - Internationalization architecture
 * Default: English. Add Telugu (te) keys to enable multi-language support.
 * Admin settings can expose language switching in future.
 */

const translations = {
  en: {
    // Navigation
    'nav.stay': 'Stay',
    'nav.celebrate': 'Celebrate',
    'nav.list_property': 'List Property',
    'nav.sign_in': 'Sign In',
    'nav.sign_out': 'Sign Out',
    'nav.dashboard': 'Dashboard',
    // Hero
    'hero.overline': 'Andhra Pradesh & Telangana',
    'hero.line1': 'Discover',
    'hero.line2': "AP & Telangana's",
    'hero.line3': 'Finest Stays &',
    'hero.line4': 'Celebrations',
    'hero.description': 'From intimate homestays to grand celebration venues — curated, verified, and just around the corner.',
    // Search
    'search.experience': 'Experience',
    'search.stay': 'Stay',
    'search.celebrate': 'Celebrate',
    'search.location': 'City or area...',
    'search.guests': 'Guests',
    'search.cta': 'Search',
    // Experiences
    'exp.stay.overline': '01 — STAY',
    'exp.stay.title': 'Your home away from home',
    'exp.stay.desc': 'Choose from homestays, hotels, PGs, hostels, and farmhouses across Andhra Pradesh and Telangana.',
    'exp.celebrate.overline': '02 — CELEBRATE',
    'exp.celebrate.title': 'Every milestone deserves a perfect venue',
    'exp.celebrate.desc': 'Function halls, banquet halls, farmhouses, and penthouses for weddings, birthdays, and corporate events.',
    // CTA — Partner Onboarding
    'partner.cta.overline': 'LIST YOUR PROPERTY ON HYGAD',
    'partner.cta.title': 'List your property. Reach thousands.',
    'partner.cta.desc': 'Pay a one-time Partner Onboarding Fee to get your property verified and listed. Limited slots available.',
    'partner.cta.button': 'Get Listed — Pay Onboarding Fee',
    // Common
    'common.enquire': 'Enquire Now',
    'common.view_all': 'View All',
    'common.loading': 'Loading...',
    'common.per_night': 'per night',
    'common.guests': 'guests',
  },
  // Telugu keys can be added here:
  // te: { 'nav.stay': 'బస', ... }
};

let currentLang = 'en';

export const setLanguage = (lang) => { currentLang = lang; };

export const t = (key, lang = null) => {
  const l = lang || currentLang;
  return translations[l]?.[key] || translations.en[key] || key;
};

export const useTranslation = () => ({ t, currentLang });
